const CONFIG = {
  elevatedliving: {
    booking: true,
    diet: false,
  },
  chitowntrainer: {
    booking: false,
    diet: true,
  },
}

export default CONFIG[import.meta.env.VITE_THEME]
